// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"1fe1fe5e","288":"c20348bc","968":"4bf96ae3"}[chunkId] + ".css";
};